import { MapPin } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATES } from "@/lib/constants";

export const StateSelect = ({ value, onChange, testId = "state-select", allowAll, light }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger
      data-testid={testId}
      className={`h-10 w-auto gap-2 rounded-full border px-4 text-sm font-semibold ${light ? "bg-white text-[#0f2a33] border-slate-200" : "bg-white/5 text-white border-white/15 hover:bg-white/10"}`}
    >
      <MapPin className="h-4 w-4 text-[#d4f253] shrink-0" style={light ? { color: "#0f2a33" } : {}} />
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {allowAll && <SelectItem value="ALL" data-testid={`${testId}-option-ALL`}>All Australia</SelectItem>}
      {STATES.map((s) => (
        <SelectItem key={s.id} value={s.id} data-testid={`${testId}-option-${s.id}`}>
          {s.name} ({s.id})
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
